import { SimpleIconProps } from '../types';

export const IconCheckMark = ({ className, color }: SimpleIconProps) => (
  <svg
    className={className}
    height="8"
    role="img"
    viewBox="0 0 9 7"
    width="10"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.441 5.436l-1.853-1.91L1 4.102l2.441 2.487 4.97-5.014L7.829 1z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);
